import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M23,13.74A.5.5,0,0,1,23,13a3.25,3.25,0,0,0,1-2.36c0-1.81-2.18-3.27-4.36-3.27a5.15,5.15,0,0,0-2.5,1.21.26.26,0,0,1-.33,0,.23.23,0,0,1,0-.32A5.19,5.19,0,0,0,18,5.74c0-2.18-1.47-4.36-3.27-4.36a3.25,3.25,0,0,0-2.37,1,.51.51,0,0,1-.72,0,3.25,3.25,0,0,0-2.37-1C7.46,1.38,6,3.56,6,5.74a5.19,5.19,0,0,0,1.21,2.5.23.23,0,0,1,0,.32.26.26,0,0,1-.33,0,5.15,5.15,0,0,0-2.5-1.21C2.18,7.38,0,8.84,0,10.65A3.25,3.25,0,0,0,1,13a.5.5,0,0,1,0,.73A3.25,3.25,0,0,0,0,16.1c0,1.81,2.18,3.28,4.36,3.28,1.34,0,3.9-1,5.69-1.82a.49.49,0,0,1,.47,0,.5.5,0,0,1,.23.42v3.36a1.25,1.25,0,0,0,2.5,0V18a.5.5,0,0,1,.23-.42.49.49,0,0,1,.47,0c1.79.79,4.35,1.82,5.69,1.82,2.18,0,4.36-1.47,4.36-3.28A3.25,3.25,0,0,0,23,13.74Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }